import esalesClient from '@/api/clients/esales'
import ModelApi from '@/api/model'
import { AxiosInstance } from 'axios'
import { Contract } from '@/modules/customers/models/customer/contract'
import { IStringDictionary, IStringIndexed } from '@/modules/shared/types'

export class ContractApi extends ModelApi {
  constructor (client: AxiosInstance) {
    super(client)

    this.urlStructure = ['customers', 'contracts']
    this.singular = 'contract'
    this.plural = 'contracts'
    this.factory = (...args: any) => new Contract(...args)
  }

  public async loadAll (customerId: number, config?: IStringDictionary<IStringDictionary<string | Array<string|number>>>): Promise<Array<Contract>> {
    return await this.loadAllSpecific(arguments, config) as Array<Contract>
  }

  public async load (customerId: number, id: number, onlyProps?: Array<string>): Promise<Contract> {
    return await this.loadSpecific(arguments, onlyProps) as Contract
  }

  public async save (customerId: number, contract: Contract) : Promise<Contract> {
    const data: IStringIndexed = { ...contract }
    return await this.saveSpecific(arguments, data) as Contract
  }

  public async delete (contact: Contract) {
    return await this.deleteSpecific([contact.customerId, contact.id])
  }
}

export const ContractsApi = new ContractApi(esalesClient)
